import $ from "jquery";
import TeaserCard from "@core/components/cards/teaser-card/teaser-card";
import SimpleBar from "simplebar";
import Utils from "@core/base/scripts/utils/utils";

export default class TeaserSlider {
  constructor() {
    this.container = null;
    this.simpleBar = null;
    this.$wrapper = null;
  }
  init(container) {
    this.container = container;
    this.$wrapper = $(".base-snap-slider", this.container);
    const teaserCard = new TeaserCard($(container));
    teaserCard.init();
    this.simpleBarInit();
  }
  simpleBarInit() {
    this.$list = $(".base-snap-slider__slider", this.container);
    if (Utils.isTablet && !this.simpleBar) {
      this.simpleBar = new SimpleBar(this.$wrapper[0], { autoHide: false });
    } else if (!Utils.isTablet && this.simpleBar) {
      this.simpleBar.unMount();
      $(".simplebar-wrapper", this.container).remove();
      $(".simplebar-track", this.container).remove();
      this.$wrapper.removeAttr("data-simplebar");
      this.$wrapper.html(this.$list);
      this.simpleBar = null;
    }
  }

  onResize() {
    setTimeout(() => {
      this.init(this.container);
    }, 0);
  }
}
